/**
 * 检测用户浏览器首选语言
 * @returns 检测到的语言代码
 */
export function detectSystemLanguage(): string {
  // 检查浏览器语言设置
  if (typeof navigator !== 'undefined') {
    const browserLang = navigator.language || navigator.languages?.[0];
    if (browserLang) {
      // 处理中文语言检测
      if (browserLang.startsWith('zh')) {
        return 'zh-Hans'; // 默认使用简体中文
      }
      // 可以根据需要添加其他语言检测逻辑
      if (browserLang.startsWith('en')) {
        return 'en';
      }
      // 返回原始语言代码
      return browserLang;
    }
  }

  // 默认返回英文
  return 'en';
}

/**
 * 根据语言选择对应的 onboarding 模板
 * @param language 语言代码
 * @returns 对应的模板文件名
 */
export function getOnboardingTemplateName(language: string): string {
  switch (language) {
    case 'zh-Hans':
    case 'zh-Hant':
      return 'onboarding-zh.zip';
    case 'en':
    default:
      return 'onboarding.zip';
  }
}
